<template>
  <el-dialog title="About Waterfall" :lock-scroll="false" :visible.sync="visible" top="6vh" width="850px" @close="$emit('close')">
    <div class="ctn">
      <div class="info">
        <div class="info-left">
          <about-item name="当前版本:" :loading="version === ''">{{ version }}</about-item>
          <!-- <about-item v-if="checkUpdateResult" name="最新版本:" :loading="checkingUpdate" :details="checkUpdateResult">{{ checkUpdateResult ? checkUpdateResult.versionInfo.version : '获取最新版本出错' }}</about-item> -->
          <about-item name="联系我们:"> watsess@163.com </about-item>
          <about-item name="官网地址:"><el-link type="primary">https://watsess.com</el-link></about-item>
          <about-item name="其它版本下载:"><el-link type="primary">https://watsess.com</el-link></about-item>
          <about-item name="Waterfall 致力于在所有架构和平台上提供一致的终端使用体验" />

          <alive v-if="isAdmin" />
        </div>
        <div class="info-right">
          <img src="@/assets/images/logo.png" alt="waterfall session logo" width="120px">
        </div>
        
      </div>
      <platforms />
    </div>
    <span slot="footer" class="dialog-footer">
      <div class="footer-ctn">
        <div class="footer-left">
          <updater ref="upd" 
          @isCheckingChanged="(isChecking) => { checkingUpdate = isChecking }" 
          @updateDownloaded="updateDownloaded = true"/>
        </div>
        <div class="footer-right">
          <el-button v-if="env.isElectron && !updateDownloaded" @click="checkUpdate" size="mini" type="primary">
            <span v-show="checkingUpdate" class="el-icon-loading" />
            <span v-show="!checkingUpdate">检查更新</span>
          </el-button>
          <el-button v-if="env.isElectron && updateDownloaded" @click="utils.electron.exitService('exitServiceForUpgrade')" size="mini" type="primary">
            <span class="el-icon-upload" />
            <span>退出并更新</span>
          </el-button>
          <el-button @click="hide" size="mini">关 闭</el-button>
        </div>
      </div>
    </span>
  </el-dialog>
</template>

<script>
import Updater from '../updater/updater.vue'
import AboutItem from './aboutItem.vue'
import Platforms from './platforms.vue'
import Alive from './alive.vue'

export default {
  name: "about",
  components: {
    AboutItem,
    Platforms,
    Updater,
    Alive,
  },
  data() {
    return {
      visible: false,
      version: "",
      checkingUpdate: false,
      updateDownloaded: false,
    }
  },
  mounted() {
    this.updateVersion()
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    updateVersion() {
      let self = this
      self.api.ver.getVer((error, data, response) => {
        if (error) {
          self.api.errHandler(self, error, response)
          return
        }
        self.version = data
      })
    },
    checkUpdate() {
      this.$refs.upd.check()
    },
    exitService() {
      console.log("exitService")
    },
  },
}
</script>

<style scoped>
.ctn {
  text-align: left;
}
.info {
  margin: 0 1.2em 3em 1.2em;
  display: flex;
  justify-content: space-between;
}
.info-left {
  flex-grow: 0;
}
.info-right {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.footer-ctn {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.footer-right {
  display: flex;
}
</style>
